export const ImpactLevels: Array<String> = [
  "High",
  "Medium",
  "Low"
]

